import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { projectsData } from "../../data/data";
import { formatTitleForUrl } from "../../utils";
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";

function Project() {
    const { projectTitle } = useParams();

    const project = projectsData.find(
        (proj) => formatTitleForUrl(proj.title) === projectTitle
    );

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");

    const handleImageClick = (image) => {
        setModalImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalImage("");
    };

    if (!project) {
        return <div>Project not found</div>;
    }

    return (
        <div className="max-w-10xl mx-auto py-6 border-b-[1px] border-b-black">
            {/* Main section with text and image */}
            <div className="flex flex-col lg:flex-row gap-8 mb-12">
                {/* Left section with text */}
                <div className="flex-1 space-y-4">
                    <h1 className="text-3xl font-bold">{project.title}</h1>
                    <h3 className="mr-1 text-base uppercase text-designColor font-normal">
                        {project.category}
                    </h3>
                    <p className="text-lg">{project.des}</p>
                    <div className="space-x-4 mt-4">
                        <div className="flex gap-2">
                            {project.github && (
                                <a href={project.github} target="_blank" rel="noreferrer">
                                    <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                                        <BsGithub />
                                    </span>
                                </a>
                            )}
                            {project.weblink && (
                                <a href={project.weblink} target="_blank" rel="noreferrer">
                                    <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                                        <FaGlobe />
                                    </span>
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                {/* Right section with the main project image */}
                <div className="flex-1">
                    <img
                        src={project.src}
                        alt={`${project.title} screenshot`}
                        className="w-full h-auto rounded-lg shadow-md"
                    />
                </div>
            </div>

            {/* Screenshots section */}
            <div className="mt-12 pt-6 border-t-[1px] border-t-black">
                <h2 className="text-2xl font-semibold mb-8">Screenshots</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {project.screenshots && project.screenshots.length > 0 ? (
                        project.screenshots.map((screenshot, index) => (
                            <div
                                key={index}
                                className="group relative overflow-hidden rounded-lg shadow-xl cursor-pointer"
                                onClick={() => handleImageClick(screenshot)}
                            >
                                <div className="relative w-full h-40">
                                    <img
                                        src={screenshot}
                                        alt={`Screenshot ${index + 1}`}
                                        className="object-cover w-full h-full transition-transform duration-300 ease-in-out transform group-hover:scale-110"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-black bg-opacity-30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out flex justify-center items-center">
                                    <span className="text-white font-semibold text-xl">View Full</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No screenshots available for this project.</p>
                    )}
                </div>
            </div>

            {/* Modal to display full image */}
            {isModalOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
                    onClick={closeModal}
                >
                    <div
                        className="relative bg-white p-[24px] rounded-lg shadow-lg
                                   w-[90%] xs:w-[90%] sm:w-[90%] md:w-[70%] lg:w-[70%] 
                                   max-h-[90vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img
                            src={modalImage}
                            alt="Full screenshot"
                            className="w-full h-auto object-contain border-[1px] border-lightText rounded-lg"
                        />
                        <button
                            className="absolute top-0 right-2 text-bodyColor text-2xl"
                            onClick={closeModal}
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Project;
